import { Timestamp } from 'firebase/firestore';

/**
 * Non-billable work categories an employee logs outside of a billable client
 * session (paid time that isn't a CPT-coded session). Kept as an enum + a
 * Firestore-backed entry so it feeds paid-vs-billable and payroll later.
 */
export type ActivityCategory =
  | 'staff-meeting'
  | 'training'
  | 'supervision'
  | 'documentation'
  | 'admin'
  | 'client-coordination'
  | 'travel'
  | 'onboarding'
  | 'required-meeting';

export const ACTIVITY_CATEGORY_LABELS: Record<ActivityCategory, string> = {
  'staff-meeting': 'Staff meeting',
  training: 'Training',
  supervision: 'Supervision',
  documentation: 'Documentation time',
  admin: 'Administrative',
  'client-coordination': 'Client coordination',
  travel: 'Travel',
  onboarding: 'Onboarding',
  'required-meeting': 'Required meeting',
};

export const ACTIVITY_CATEGORIES = Object.keys(ACTIVITY_CATEGORY_LABELS) as ActivityCategory[];

export type ActivityEntryStatus = 'open' | 'closed';

export interface ActivityEntry {
  id: string;
  companyId: string;
  rbtId: string;
  rbtName: string;
  category: ActivityCategory;
  notes?: string;
  startTime: Timestamp;
  endTime?: Timestamp;
  minutes?: number;         // set when closed
  status: ActivityEntryStatus;
  createdAt: Timestamp;
  updatedAt: Timestamp;
}
